import React from 'react'
import { useAuth } from 'wasp/client/auth'

export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { data: user, isLoading } = useAuth()
  if (isLoading) return null
  if (!user) return <div className="p-4">Please sign in.</div>
  if (!user.isAdmin) return <div className="p-4">403 • Not authorized</div>
  return <>{children}</>
}

